<app-page-breadcrumb [pageTitle]="pageTitle"></app-page-breadcrumb>

<div class="grid grid-cols-1 gap-6">
  <app-component-card [title]="pageTitle" desc="Complete los datos del atributo de contacto">

    <!-- Loading -->
    @if (loading) {
    <div class="flex justify-center items-center py-12">
      <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-brand-500"></div>
      <span class="ml-3 text-gray-500 dark:text-gray-400">Cargando datos...</span>
    </div>
    }

    <!-- Error -->
    @if (error) {
    <div class="mb-4 p-4 bg-error-50 border border-error-200 rounded-lg dark:bg-error-500/10 dark:border-error-500/20">
      <div class="flex items-center gap-3">
        <svg class="w-5 h-5 text-error-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
        </svg>
        <p class="text-error-600 dark:text-error-400">{{ error }}</p>
      </div>
    </div>
    }

    <!-- Formulario -->
    @if (!loading) {
    <form (ngSubmit)="guardar()" #attributeForm="ngForm" class="space-y-5">

      <!-- Nombre del Atributo (código) -->
      <div>
        <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
          Nombre del Atributo <span class="text-error-500">*</span>
        </label>
        <input
          type="text"
          name="attributeName"
          [(ngModel)]="attributeName"
          #attributeNameField="ngModel"
          required
          maxlength="30"
          placeholder="ej: idContactState"
          class="dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 dark:focus:border-brand-800 disabled:opacity-50 disabled:cursor-not-allowed font-mono"
        />
        @if (attributeNameField.invalid && (attributeNameField.dirty || attributeNameField.touched) && attributeNameField.errors?.['maxlength']) {
          <p class="mt-1 text-xs text-error-500">La cantidad máxima de caracteres permitida es de 30.</p>
        }
        <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">Nombre del campo Java, ej: idContactState</p>
      </div>

      <!-- Etiqueta Visible -->
      <div>
        <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
          Etiqueta Visible <span class="text-error-500">*</span>
        </label>
        <input
          type="text"
          name="displayName"
          [(ngModel)]="displayName"
          required
          placeholder="ej: Estado de Contacto"
          class="dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 dark:focus:border-brand-800 disabled:opacity-50 disabled:cursor-not-allowed"
        />
        <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">Nombre amigable que se mostrará en la interfaz</p>
      </div>

      <!-- Tipo de Valor -->
      <div>
        <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
          Tipo de Valor
        </label>
        <select
          name="valueType"
          [(ngModel)]="valueType"
          class="dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:focus:border-brand-800 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <option value="STRING">Texto (STRING)</option>
          <option value="NUMBER">Número (NUMBER)</option>
          <option value="FK">Clave Foránea (FK)</option>
        </select>
        <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">Tipo de dato que almacena este atributo</p>
      </div>

      <!-- Estado -->
      <div class="flex items-start gap-3">
        <input
          type="checkbox"
          name="isActive"
          [(ngModel)]="isActive"
          id="isActive"
          class="mt-0.5 h-4 w-4 rounded border-gray-300 text-brand-500 focus:ring-brand-500/10 dark:border-gray-600 dark:bg-gray-800"
        />
        <div>
          <label for="isActive" class="text-sm font-medium text-gray-700 dark:text-gray-300">
            Atributo activo
          </label>
          <p class="text-xs text-gray-500 dark:text-gray-400">
            Si está desmarcado, el atributo no estará disponible para reglas
          </p>
        </div>
      </div>

      <!-- Botones -->
      <div class="flex items-center justify-end gap-3 pt-4 border-t border-gray-200 dark:border-gray-700">
        <app-button
          variant="outline"
          type="button"
          (btnClick)="cancelar()"
        >
          Cancelar
        </app-button>
        <app-button
          variant="primary"
          type="submit"
          [disabled]="saving"
        >
          {{ saving ? 'Guardando...' : (isEditing ? 'Actualizar' : 'Crear Atributo') }}
        </app-button>
      </div>
    </form>
    }
  </app-component-card>
</div>
